import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import { modalGenericStyles, variables } from "../../../../variables";
import PropTypes from "prop-types";
import Loader from "../../../../components/Loader";
import { CustomButton } from "../../../../components/CustomButton";

const styles = createUseStyles({
  ...modalGenericStyles,
  SendCancellationEmail: {
    ...modalGenericStyles.modal,
  },
  cardBody: {
    ...modalGenericStyles.cardBody,
    display: "grid",
    gridGap: variables.normal_gap,
    justifyContent: "center",
    alignContent: "center",
  },
});

const SendCancellationEmail = ({ title, message, onSubmit, onClose }) => {
  const classes = styles();
  const [loading] = useState(false);
  return (
    <div className={classes.SendCancellationEmail}>
      {loading ? (
        <Loader />
      ) : (
        <div className={classes.card}>
          <div className={classes.cardHeader}>
            <span>{title}</span>
          </div>
          <div className={classes.cardBody}>{message}</div>
          <div className={classes.cardActions}>
            <CustomButton appearance="ghost" onClick={() => onClose()}>
              <strong>Cancel</strong>
            </CustomButton>
            <CustomButton
              appearance="primary"
              onClick={(e) => {
                e.preventDefault();
                onSubmit();
                onClose();
              }}>
              <strong>Submit</strong>
            </CustomButton>
          </div>
        </div>
      )}
    </div>
  );
};
SendCancellationEmail.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default SendCancellationEmail;
